const usersObjectToQuery = selectedUsers => (selectedUsers.map((user) => (user.value)).join(','))

export default usersObjectToQuery;